module.exports = __webpack_public_path__ + "static/media/medium.e677dfe5.jpg";